/**
 * Google API Configuration
 *
 * Google Cloud Platform API keys and settings.
 * Keys live in .env.local — never hardcode them here; this file is in the repo.
 */

// PLACES API NEW (account: support@hivemodern.com)
// NEXT_PUBLIC_ because the key is embedded in the client-side Maps script URL.
// Restrict it to hivemodern.com referrers in the Google Cloud console.
export const GOOGLE_PLACES_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY
